import apiInstance from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'

const GetSelectedInfluencer = (id_ean: string) => {
  return apiInstance.get(ApiPathConfig.EXPORT_SELECTED_INFLUENCER(id_ean))
}

export default GetSelectedInfluencer
